import React, { useMemo } from 'react';
import { ReactComponent as ShareIcon } from '@zonofi/svg-icons/forward-icon.svg';
import { SVGS } from '../../assets';
import { OptionsTooltip, OptionsTooltipItem } from '../tool-tip';

export type ActionType =
  | 'ORDER'
  | 'INVOICE'
  | 'PAYMENT'
  | 'DISPACH_NOTE'
  | 'MANAGE_CUSTOMERS';

interface SendActionTooltipProps {
  type: ActionType;
  onInvoicePress?: () => void;
  onPaymentRequest?: () => void;
  onShareInvoice?: () => void;
  onSendPayment?: () => void;
  onSendDispatchNote?: () => void;
  onSendOrderReceipt?: () => void;
  onSendCustomer?: () => void;
}

export const SendActionTooltip: React.FC<SendActionTooltipProps> = ({
  type,
  onInvoicePress = () => {},
  onPaymentRequest = () => {},
  onShareInvoice,
  onSendPayment = () => {},
  onSendDispatchNote = () => {},
  onSendOrderReceipt = () => {},
  onSendCustomer = () => {},
}) => {
  const actionConfig: Record<ActionType, OptionsTooltipItem[]> = useMemo(
    () => ({
      ORDER: [
        {
          id: 'orderReceipt',
          icon: SVGS.OrdersBlackIcon,
          text: 'Send Order Receipt',
          onPress: onSendOrderReceipt,
        },
      ],
      INVOICE: [
        {
          id: 'paymentRequest',
          icon: SVGS.SendPayment,
          text: 'Send Payment Request',
          onPress: onPaymentRequest,
        },
        {
          id: 'sendInvoices',
          icon: SVGS.SendInvoice,
          text: 'Send Invoices',
          onPress: onInvoicePress,
        },
        ...(onShareInvoice
          ? [
              {
                id: 'shareInvoice',
                icon: <ShareIcon width={20} height={20} />,
                text: 'Share Invoice',
                onPress: onShareInvoice,
              },
            ]
          : []),
      ],
      PAYMENT: [
        {
          id: 'sendPayment',
          icon: SVGS.SendPayment,
          text: 'Send Payment Receipt',
          onPress: onSendPayment,
        },
      ],
      DISPACH_NOTE: [
        {
          id: 'sendDispatchNote',
          icon: SVGS.Notepad,
          text: 'Send Dispatch Note',
          onPress: onSendDispatchNote,
        },
      ],
      MANAGE_CUSTOMERS: [
        {
          id: 'sendManageCustomer',
          icon: '',
          text: 'Include/Exclude Customer',
          onPress: onSendCustomer,
        },
      ],
    }),
    [
      onInvoicePress,
      onPaymentRequest,
      onShareInvoice,
      onSendPayment,
      onSendDispatchNote,
      onSendOrderReceipt,
      onSendCustomer,
    ]
  );

  return <OptionsTooltip actions={actionConfig[type]} />;
};
